<template>
  <div>
    <v-autocomplete
      v-model="filter.userId"
      :items="users"
      item-text="name"
      item-value="id"
      dense
      outlined
      no-data-text="Nenhum dado encontrado"
      background-color="#f5f5f5"
      append-icon="mdi-chevron-down"
      prepend-inner-icon="mdi-magnify"
      class="ma-2"
      placeholder="Pesquisar usuário"
      clearable
      @click:prepend-inner="getChats"
      @keyup.enter="getChats"
      @change="getChats"
    ></v-autocomplete>

    <div class="tabs-container mx-2 mb-3">
      <button
        :class="['tab-btn', { active: !showUnreadOnly }]"
        @click=";(showUnreadOnly = false), getChats()"
      >
        Todas
      </button>
      <button
        :class="['tab-btn', { active: showUnreadOnly }]"
        @click=";(showUnreadOnly = true), getChats()"
      >
        Não lidas
        <span v-if="unreadCount > 0" class="badge-count">
          {{ notReadedMessages.length }}
        </span>
      </button>
    </div>

    <strong class="ml-2"> Solicitações: </strong>

    <div id="senders">
      <v-card
        v-if="filteredChats.length == 0"
        flat
        class="d-flex justify-center align-center ma-2 pa-4 primary white--text"
      >
        <div>
          <strong>
            {{
              showUnreadOnly
                ? 'Nenhuma solicitação não lida encontrada!'
                : 'Nenhuma solicitação encontrada!'
            }}
          </strong>
        </div>
      </v-card>
      <div v-else>
        <v-card
          v-if="showIntersecCard && pager.totalPages > 1 && !showUnreadOnly"
          v-intersect="getMoreChats"
          style="height: 1px"
        >
        </v-card>

        <div
          v-for="item in filteredChats"
          :key="JSON.stringify(item) + item.lastMessageContent"
        >
          <v-card
            class="pa-2 ma-2"
            color="#f9f9f9"
            flat
            @click="$emit('select', item)"
            style="position: relative"
          >
            <div
              style="
                position: absolute;
                top: 10px;
                right: 10px;
                border-radius: 50%;
                background: #b9ce1e;
                width: 25px;
                height: 25px;
                color: white;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
              "
              v-if="item.notReadedMessages && item.notReadedMessages.length"
            >
              {{ item.notReadedMessages.length }}
            </div>

            <v-row class="ma-0" align="center">
              <v-col cols="10">
                <strong class="secondary--text">
                  {{ item.user.name }}
                </strong>

                ({{ offices[item.user.userOffice] }} em

                <strong
                  >{{
                    item.user &&
                    item.user.institutions &&
                    item.user.institutions[0] &&
                    item.user.institutions[0].institution
                      ? item.user.institutions[0].institution.name
                      : ''
                  }} </strong
                >)

                <div
                  class="my-1 pa-2"
                  style="background: #e9e9e9; border-radius: 8px"
                >
                  <strong style="font-size: 12px">
                    {{ getChatHours(item.lastMessageDate) }}
                  </strong>
                  :
                  {{ item.lastMessageContent.substring(0, 6) }}...
                </div>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <v-icon>mdi-chevron-right</v-icon>
              </v-col>
            </v-row>
          </v-card>

          <v-divider class="mx-8"></v-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tabs-container {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tab-btn {
  padding: 8px 20px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  outline: none;
}

.tab-btn:hover {
  background: #f0f0f0;
}

.tab-btn.active {
  background: #b9ce1e;
  color: white;
}

.tab-btn.active:hover {
  background: #cbde38;
}

.badge-count {
  background: rgba(255, 255, 255, 0.3);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}

#senders {
  overflow-y: auto;
  height: 60vh;
  scroll-snap-type: y proximity;
}

#senders::-webkit-scrollbar {
  width: 8px;
  border-radius: 6px;
}

#senders::-webkit-scrollbar-thumb {
  width: 8px;
  border-radius: 6px;
}
</style>

<script>
import ApiService from '../../services/ApiService'
import moment from 'moment'

export default {
  name: 'ChatComponent',

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getUsers()
    this.getChats()
    this.addSocket()
    if (this.institution.userType == 0) this.getNotReadedMessages()
  },

  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },

  destroy() {
    if (this.socket) {
      this.socket.close()
    }
  },

  data() {
    return {
      userLoading: false,
      users: [],
      user: {},
      socket: null,
      showIntersecCard: false,
      showUnreadOnly: false,
      apiService: new ApiService(),
      loading: false,
      filter: {
        userId: '',
        page: 1,
        pageSize: 12,
      },
      chats: [],
      pager: {},
      institution: {},
      notReadedMessages: [],
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
      ],
    }
  },

  computed: {
    filteredChats() {
      return this.chats
    },

    unreadCount() {
      return this.chats.filter(
        (chat) => chat.notReadedMessages && chat.notReadedMessages.length > 0
      ).length
    },
  },

  methods: {
    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/listAll`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
        .catch(() => {
          this.userLoading = false
        })
    },

    addSocket() {
      if (this.socket) this.socket.close()

      this.socket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=MASTER&userId=${this.user.id}`
      )

      const $context = this

      this.socket.onmessage = async function (e) {
        const socketMessage = await JSON.parse(e.data)

        if (socketMessage.chat) {
          var findChatIdx = $context.chats.findIndex(
            (x) => x.id == socketMessage.chat.id
          )

          var findChat = $context.chats.find(
            (x) => x.id == socketMessage.chat.id
          )

          if (findChatIdx > -1) {
            const el = $context.chats.splice(findChatIdx, 1)[0]
            $context.chats.splice(0, 0, el)

            findChat.lastMessageContent = socketMessage.chat.lastMessageContent
            findChat.lastMessageDate = socketMessage.chat.lastMessageDate
            findChat.notReadedMessages = socketMessage.chat.notReadedMessages
          } else $context.chats.unshift(socketMessage.chat)

          $context.chats = $context.chats.sort(function (a, b) {
            const date1 = moment(a.lastMessageDate).format('yyyy-MM-DD')
            const date2 = moment(b.lastMessageDate).format('yyyy-MM-DD')
            return new Date(date2) - new Date(date1)
          })
        }
      }
    },

    getChatHours(date) {
      if (date) {
        if (
          moment(date).format('HH:mm') === moment(new Date()).format('HH:mm')
        ) {
          return 'Agora'
        }

        if (
          moment(date).format('DD/MM/yyyy') !==
          moment(new Date()).format('DD/MM/yyyy')
        ) {
          return moment(date)
            .locale(this.$i18n.locale)
            .format('DD/MM/yyyy HH:mm')
        }

        return moment(date).locale(this.$i18n.locale).format('HH:mm')
      }

      return date
    },

    getNotReadedMessages() {
      this.apiService
        .get(`chat/master/notReaded`, null, true, false)
        .then((response) => {
          this.notReadedMessages = response.content
        })
    },

    getChats() {
      this.apiService
        .get(`chat/senders`, {
          userId: this.filter.userId,
          page: 1,
          pageSize: 12,
          onlyUnread: this.showUnreadOnly,
        })
        .then((response) => {
          this.chats = response.content.data
          this.pager = response.content.pager

          setTimeout(() => {
            this.showIntersecCard = true
          }, 1000)
        })
    },

    getMoreChats(entries, observer) {
      if (entries[0].isIntersecting) {
        this.filter.page++
        if (this.filter.page <= this.pager.endPage) {
          this.showIntersecCard = false

          this.apiService.get(`chat/senders`, this.filter).then((response) => {
            this.chats.push(...response.content.data)
            this.pager = response.content.pager

            setTimeout(() => {
              this.showIntersecCard = true
            }, 1000)
          })
        }
      }
    },
  },
}
</script>
